import { PLAQUES } from "../../content/plaques";
import { progressFor } from "../../engine/plaques";
import { profile } from "../../state/store";

/** 36 plaques. Earned = full color + date. Milestone/skill unearned =
    ghosted with a progress bar when quantifiable. Secret unearned = a
    silhouette — name/how never leak before it's earned. */
export function PlaqueGrid() {
  const p = profile.value;

  return (
    <div class="plaque-grid">
      {PLAQUES.map((pl) => {
        const earned = p.plaques[pl.id];

        if (earned) {
          return (
            <div key={pl.id} class="plaque plaque-earned">
              <p class="display plaque-name">{pl.name}</p>
              <p class="plaque-how">{pl.how}</p>
              <p class="mono plaque-date">{earned.at}</p>
            </div>
          );
        }

        if (pl.class === "secret") {
          return (
            <div key={pl.id} class="plaque plaque-secret" aria-label="Secret plaque, not yet earned">
              <p class="display plaque-name">???</p>
            </div>
          );
        }

        const progress = progressFor(pl.id, p);
        return (
          <div key={pl.id} class="plaque plaque-ghost">
            <p class="display plaque-name">{pl.name}</p>
            <p class="plaque-how">{pl.how}</p>
            {progress && (
              <>
                <div class="closest-plaque-bar">
                  <div class="closest-plaque-fill" style={{ width: `${(progress.current / progress.target) * 100}%` }} />
                </div>
                <p class="mono plaque-date">
                  {progress.current} / {progress.target}
                </p>
              </>
            )}
          </div>
        );
      })}
    </div>
  );
}
